
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M9.03 4.812c-.011 2.242-1.402 6.19-2.321 6.81h1.163c.456 0 .456.469 1.144.469s.688-.47 1.167-.47c.48 0 .408.47 1.115.47.706 0 .706-.47 1.196-.47s.548.47 1.124.47c.384 0 .76-.157 1.126-.47v2.234c0 .632-.513 1.145-1.146 1.145H2.145A1.145 1.145 0 011 13.855v-1.088c0-.633.513-1.146 1.145-1.146h.003c.887 0 5.576-2.765 5.6-6.809-2.919.012-3.528 2.63-3.528 3.438 0 .81-.93.502-1.108 0-.267-.75-.808-5.115 4.174-4.772.47 0-.944-.639-2.454-.639-1.51 0-2.965 1.5-2.965 2.541S.777 1 5.287 1c2.01 0 3.136 1.839 3.306 1.839.171 0 .855-1.356 2.924-1.356S15 3.71 15 5.98c0 .496.07-2.503-4.416-2.503-.218 0 1.435.611 2.195 1.78.759 1.17.39 2.98 0 3.48-.105.135-.66.237-.77-.245-.259-1.5-.697-3.68-2.952-3.68h-.026z"}})])
          )
        }
      }
    